var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSocialFb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.8 0H2.2C1.61652 0 1.05695 0.231785 0.644365 0.644365C0.231785 1.05695 0 1.61652 0 2.2V37.8C0 38.3835 0.231785 38.9431 0.644365 39.3556C1.05695 39.7682 1.61652 40 2.2 40H21.36V24.5H16.16V18.5H21.36V14C21.2523 12.9435 21.377 11.8763 21.7254 10.8731C22.0739 9.8699 22.6375 8.95509 23.3769 8.19282C24.1163 7.43055 25.0135 6.83928 26.0057 6.46048C26.9978 6.08167 28.0607 5.9245 29.12 6C30.6767 5.99042 32.2326 6.07055 33.78 6.24V11.64H30.6C28.08 11.64 27.6 12.84 27.6 14.58V18.44H33.6L32.82 24.44H27.6V40H37.8C38.0889 40 38.375 39.9431 38.6419 39.8325C38.9088 39.722 39.1513 39.5599 39.3556 39.3556C39.5599 39.1513 39.722 38.9088 39.8325 38.6419C39.9431 38.375 40 38.0889 40 37.8V2.2C40 1.91109 39.9431 1.62501 39.8325 1.3581C39.722 1.09118 39.5599 0.848654 39.3556 0.644365C39.1513 0.440076 38.9088 0.278026 38.6419 0.167465C38.375 0.0569049 38.0889 0 37.8 0Z",
    fill: "#3B5998"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialFb);
export default __webpack_public_path__ + "static/media/social-fb.35ae5057c5a6e58beaaa6d8e924ec407.svg";
export { ForwardRef as ReactComponent };